import { string } from 'yup'

export const createSsidPassphraseSchema = (t: (key: string) => string) =>
  string()
    .required(t('ui_elements.required_field'))
    .matches(/^[a-zA-Z0-9_\s\-?.;]{8,}$/, t('event_ssids.errors.passphrase_invalid'))
    .min(8, t('event_ssids.errors.passphrase_min_length'))
    .max(63, t('event_ssids.errors.passphrase_max_length'))
